import Image from 'next/image';
import * as schema from '@/db/schema';

export function ChatPhoto({
  chat,
}: {
  chat: typeof schema.tg_chats.$inferSelect;
}) {
  if (chat.photo_url) {
    return (
      <Image
        className="rounded-full"
        src={chat.photo_url}
        alt={chat.name}
        width={40}
        height={40}
      />
    );
  }

  return (
    <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-xl font-semibold">
      {chat.name[0]}
    </div>
  );
}
